import { Component } from "@angular/core";

@Component({
  selector: "kwikui",
  templateUrl: "./kwikui.component.html",
  styleUrls: ["./kwikui.component.scss"]
})
export class KwikUIComponent {
  constructor() {}
}
